import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import DateOption1 from "../Components/DateOption1";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import { ReactComponent as IconInfoFill } from "../Images/icon_info_fill.svg";
import { ReactComponent as IconPlus } from "../Images/icon_plus.svg";
import Layout from "../Layout/Layout";
import AddGifticon from "../Modals/AddGifticon";
import AlarmApply from "../Modals/AlarmApply";
import AlarmCancel from "../Modals/AlarmCancel";
import AlarmInputCheck from "../Modals/AlarmInputCheck";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const ChallengeApplyContent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;

  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());

  const [selectedItem, setSelectedItem] = useState(null);
  const [alarmState, setAlarmState] = useState({ show: false, type: "" });
  const [clickAddGifticon, setClickAddGifticon] = useState(false);

  const [clickInfo, setClickInfo] = useState(false);
  const iconRef = useRef(null);
  const infoBoxRef = useRef(null);
  const lastChallengeDetailRequestKey = useRef(null);

  const [stepValue, setStepValue] = useState(0);

  const [isButtonEnabled, setIsButtonEnabled] = useState(
    startTime && endTime && stepValue && selectedItem
  );
  const [disableState, setDisableState] = useState({
    startDate: false,
    endDate: false,
    step: false,
    gifticon: false,
  });

  const handleApply = () => {
    if (!isButtonEnabled) {
      setAlarmState({ show: true, type: "input_check" });
    } else {
      setAlarmState({ show: true, type: "apply" });
    }
  };

  const handleCancel = () => {
    setAlarmState({ show: true, type: "cancel" });
  };

  useEffect(() => {
    setIsButtonEnabled(startTime && endTime && stepValue && selectedItem);
  }, [startTime, endTime, stepValue, selectedItem]);

  const handleClickInfo = () => {
    setClickInfo(!clickInfo);
  };

  const handleClickOutside = (event) => {
    if (
      iconRef.current &&
      !iconRef.current.contains(event.target) &&
      infoBoxRef.current &&
      !infoBoxRef.current.contains(event.target)
    ) {
      setClickInfo(false);
    }
  };

  const getChallengeDetail = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getDetail",
        { companyChallengeId: id },
        navigate
      );

      if (res.code === 200) {
        setStartTime(new Date(res.data.startTime));
        setEndTime(new Date(res.data.endTime));
        setStepValue(res.data.step);
        setSelectedItem({
          orderItemId: res.data.orderItemId,
          goodsImgS: res.data.goodsImgS,
          brandName: res.data.brandName,
          goodsName: res.data.goodsName,
          quantity: res.data.quantity,
          availableCount: res.data.availableCount,
        });
      }
    } catch (error) {
      console.error("챌린지 상세 가져오기 중 에러:", error);
    }
  };

  const createChallenge = async () => {
    try {
      const body = {
        orderItemId: selectedItem.orderItemId,
        quantity: selectedItem.quantity,
        step: stepValue,
        startTime: startTime.toISOString().split("T")[0],
        endTime: endTime.toISOString().split("T")[0],
      };

      const res = await postJson(
        "/dashboard/gifticonChallenge/create",
        body,
        navigate
      );

      if (res.code === 200) {
        navigate("/challenge", {
          state: { toast_enable: true, type: "success" },
        });
      } else if (res.code === 1014) {
        navigate("/challenge", { state: { error: true, message: "갯수초과" } });
      } else if (res.code === 1015) {
        navigate("/challenge", { state: { error: true, message: "대회중복" } });
      }
    } catch (error) {
      console.error("챌린지 등록 중 에러:", error);
    }
  };

  const updateChallenge = async () => {
    try {
      const body = {
        companyChallengeId: id,
        orderItemId: selectedItem.orderItemId,
        quantity: selectedItem.quantity,
        step: stepValue,
        startTime: startTime,
        endTime: endTime,
      };

      const res = await postJson(
        "/dashboard/gifticonChallenge/update",
        body,
        navigate
      );

      if (res.code === 200) {
        navigate("/challenge", {
          state: { toast_enable: true, type: "success" },
        });
      } else if (res.code === 1014) {
        navigate("/challenge", { state: { error: true, message: "갯수초과" } });
      }
    } catch (error) {
      console.error("챌린지 등록 중 에러:", error);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isEditing) {
      return;
    }

    const requestKey = JSON.stringify({ id });

    if (lastChallengeDetailRequestKey.current === requestKey) {
      return;
    }

    lastChallengeDetailRequestKey.current = requestKey;
    getChallengeDetail();
  }, [id, isEditing]);

  useEffect(() => {
    if (isEditing) {
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (endDate.getTime() < today.getTime()) {
        setDisableState({
          startDate: true,
          endDate: true,
          step: true,
          gifticon: true,
        });
      } else if (
        startDate.getTime() < today.getTime() &&
        endDate.getTime() > today.getTime()
      ) {
        setDisableState({
          startDate: true,
          endDate: false,
          step: false,
          gifticon: false,
        });
      } else {
        setDisableState({
          startDate: false,
          endDate: false,
          step: false,
          gifticon: false,
        });
      }
    }
  }, []);

  return (
    <div>
      {alarmState.show &&
        (alarmState.type === "input_check" ? (
          <AlarmInputCheck
            handleClickX={() => setAlarmState({ show: false, type: "" })}
          />
        ) : alarmState.type === "apply" ? (
          <AlarmApply
            title="챌린지를 등록하시겠습니까?"
            subtitle="등록 시 해당 기간 내에 챌린지가 진행됩니다."
            handleApply={isEditing ? updateChallenge : createChallenge}
            handleClickX={() => setAlarmState({ show: false, type: "" })}
          />
        ) : (
          <AlarmCancel
            title="작성하던 내용을 취소하시겠습니까?"
            subtitle="작성하던 내용은 저장되지 않습니다."
            handleCancel={() => navigate("/challenge")}
            handleClickX={() => setAlarmState({ show: false, type: "" })}
          />
        ))}
      {clickAddGifticon && (
        <AddGifticon
          handleClickX={() => setClickAddGifticon(false)}
          handleApply={setSelectedItem}
          selectedInfo={selectedItem}
        />
      )}
      <ChallengeApplyBox>
        <div className="title-in-box">
          우리기업 챌린지 {isEditing ? "수정" : "등록"}
        </div>
        <div className="hrz-wrapper">
          <div
            className="text-for-notice"
            style={{ marginLeft: "auto", marginTop: "10px" }}
          >
            *표시는 필수 입력 항목입니다.
          </div>
        </div>

        <div
          className="bold-text"
          style={{ marginTop: "30px", marginBottom: "8px", fontSize: "18px" }}
        >
          옵션 선택
        </div>

        <div className="blueBorderBox">
          <div className="hrz-wrapper">
            <p className="medium-text">챌린지 기간 설정*</p>
            <div style={{ display: "flex", marginLeft: "auto" }}>
              <IconInfo
                fill="#888888"
                width="20px"
                height="20px"
                style={{ marginTop: "1px" }}
              />
              <p
                style={{
                  fontSize: "15px",
                  color: "#888888",
                  marginLeft: "4px",
                }}
              >
                설정한 기간 동안 챌린지를 진행하고 기프티콘을 받을 수 있어요.
              </p>
            </div>
          </div>

          <div style={{ height: "14px" }} />

          <DateOption1
            startTitle="시작일"
            endTitle="종료일"
            startDate={startTime}
            endDate={endTime}
            setStartDate={setStartTime}
            setEndDate={setEndTime}
            gap="30px"
            startDateDisabled={disableState.startDate}
            endDateDisabled={disableState.endDate}
          />
        </div>

        <div className="blueBorderBox" style={{ marginTop: "14px" }}>
          <div className="hrz-wrapper">
            <p className="medium-text">목표 걸음 수 설정*</p>
            <div
              style={{
                width: "125px",
                height: "32px",
                borderRadius: "4px",
                backgroundColor: "#f5f5f5",
                display: "flex",
                padding: "5px 8px",
                boxSizing: "border-box",
                marginLeft: "auto",
                cursor: "pointer",
              }}
              onClick={handleClickInfo}
            >
              <p
                className="medium-text"
                style={{ color: "#555555", fontSize: "14px" }}
              >
                달성률 가이드
              </p>
              <IconInfoFill
                width="24px"
                height="24px"
                style={{ marginLeft: "4px" }}
              />
              {clickInfo && (
                <div
                  style={{
                    width: "278px",
                    padding: "16px 20px",
                    boxSizing: "border-box",
                    borderRadius: "12px",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    position: "absolute",
                    marginTop: "37px",
                    marginLeft: "-8px",
                  }}
                >
                  <p
                    className="medium-text"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  >
                    성인 한달 걸음수에 따른 평균 달성률 안내
                    <br />
                    10만 걸음 : 90%
                    <br />
                    20만 걸음 : 60%
                    <br />
                    25만 걸음 : 40%
                    <br />
                    30만 걸음 : 20%
                  </p>
                </div>
              )}
            </div>
          </div>

          <div
            className="center"
            style={
              disableState.step
                ? {
                    marginTop: "14px",
                    height: "60px",
                    boxShadow: stepValue
                      ? "inset 0 -2px 0 #1167ed"
                      : "inset 0 -2px 0 #b0b0b0",
                    backgroundColor: "#f5f5f5",
                    color: "#888888",
                  }
                : {
                    marginTop: "14px",
                    height: "60px",
                    boxShadow: stepValue
                      ? "inset 0 -2px 0 #1167ed"
                      : "inset 0 -2px 0 #b0b0b0",
                  }
            }
          >
            <div className="hrz-wrapper">
              <input
                type="text"
                className="inputBox"
                placeholder="걸음수를 입력해주세요"
                onChange={(e) => setStepValue(Number(e.target.value))}
                style={
                  disableState.step
                    ? { backgroundColor: "#f5f5f5", color: "#888888" }
                    : {}
                }
                value={stepValue ? stepValue : ""}
              />
              <p className="medium-text" style={{ color: "#888888" }}>
                걸음
              </p>
            </div>
          </div>

          <p style={{ color: "#888888", fontSize: "14px", marginTop: "8px" }}>
            *전체 구성원이 아닌 각 구성원이 달성해야하는 목표 걸음수 입니다.
            <br />
            *걸음수는 나중에 수정할 수 있습니다.
          </p>
        </div>

        <div className="blueBorderBox" style={{ marginTop: "14px" }}>
          <p className="medium-text">기프티콘 등록*</p>
          <p style={{ fontSize: "14px", color: "#888888", marginTop: "14px" }}>
            챌린지 달성 시 제공할 기프티콘을 선택하고 설정해주세요.
            <br />
            소진 임박하면 알림으로 알려드려요!
          </p>
          <div style={{ marginTop: "40px" }}>
            <AddGifticonBtn
              handleClickAdd={() => setClickAddGifticon(true)}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              disabled={disableState.gifticon}
            />
          </div>
        </div>

        <div style={{ display: "flex", marginTop: "30px" }}>
          <div
            className="cancelBtn center"
            style={{ marginLeft: "auto" }}
            onClick={handleCancel}
          >
            취소
          </div>
          <div
            className="applyBtn center"
            style={{ marginLeft: "16px" }}
            onClick={handleApply}
          >
            등록
          </div>
        </div>
      </ChallengeApplyBox>
    </div>
  );
};

const AddGifticonBtn = ({
  handleClickAdd,
  selectedItem,
  setSelectedItem,
  disabled,
}) => {
  return (
    <AddBtn>
      {selectedItem ? (
        <div className="itemBox">
          {/* 사진 */}
          <div style={{ width: "80px", height: "80px" }}>
            <img
              src={selectedItem.goodsImgS}
              style={{ width: "100%", height: "100%" }}
            />
          </div>

          {/* 브랜드명/기프티콘명/갯수 */}
          <div style={{ marginLeft: "18px", marginTop: "4px" }}>
            <p className="bold-text" style={{ fontSize: "14px" }}>
              {selectedItem.brandName}
            </p>
            <p>{selectedItem.goodsName}</p>
            <div style={{ display: "flex" }}>
              <p className="bold-text" style={{ fontSize: "18px" }}>
                {selectedItem.quantity?.toLocaleString()}개
              </p>
              <p
                style={{
                  fontSize: "14px",
                  marginTop: "4px",
                  marginLeft: "4px",
                }}
              >
                {"("}발급 가능 : {selectedItem.availableCount?.toLocaleString()}
                개{")"}
              </p>
            </div>
          </div>

          {/* 삭제 | 변경하기 */}
          {!disabled && (
            <div
              style={{ display: "flex", marginLeft: "auto", marginTop: "auto" }}
            >
              <div
                style={{ width: "48px", boxShadow: "inset 0 0 0 1px #e4e4e4" }}
                className="editButton center"
                onClick={() => setSelectedItem(null)}
              >
                삭제
              </div>
              <div
                style={{
                  width: "72px",
                  backgroundColor: "#f5f5f5",
                  marginLeft: "8px",
                }}
                className="editButton center"
                onClick={handleClickAdd}
              >
                변경하기
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="plusButtonBox" onClick={handleClickAdd}>
          <IconPlus stroke="#888888" width="40px" height="40px" />
        </div>
      )}
    </AddBtn>
  );
};

const ChallengeApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;

  .inputBox {
    width: 617px;
    font-size: 20px;
    border: none;
    outline: none;
  }
  .inputBox::placeholder {
    color: #b0b0b0;
  }
`;

const AddBtn = styled.div`
  .itemBox {
    width: 695px;
    height: 120px;
    border-radius: 10px;
    display: flex;
    box-shadow: inset 0 0 0 1px #e4e4e4;
    padding: 20px;
    box-sizing: border-box;
  }
  .plusButtonBox {
    width: 695px;
    height: 120px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #f5f5f5;
  }
  .editButton {
    height: 36px;
    border-radius: 8px;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #929292;
    cursor: pointer;
  }
`;

const ChallengeApply = () => {
  return <Layout page={<ChallengeApplyContent />} />;
};

export default ChallengeApply;
